import { LoaderFunctionArgs, useLoaderData } from "react-router"
import { DocsRouterLink as RouterLink } from "~/docs-data/docs-link"
import { H1, P, Section } from "~/components/Typography"
import { getCountryCatalog } from "~/docs-data/helpers"
import { supplySources } from "~/docs-data/concepts"
import { getDocsCatalogForRequest } from "~/server/docs-catalog-store.server"
export const loader = async ({ request, params }: LoaderFunctionArgs) => {
  const { countries } = await getDocsCatalogForRequest(request)
  const cc = getCountryCatalog(countries, params.country ?? "")
  if (!cc) throw new Response("Not found", { status: 404 })
  const supplyForCountry = supplySources.filter((s) => s.country === cc.countryCode)
  return { cc, supplyForCountry }
}

export default function CountrySupplySources() {
  const { cc, supplyForCountry } = useLoaderData<typeof loader>()

  return (
    <div className="max-w-screen-xl">
      <Section>
        <H1>Signal sources</H1>
        <P>
          The underlying signals (GPS panels, telco networks, and so on) that feed metric models in{" "}
          {cc.name}. A metric model's quality and limitations follow from its signal.
        </P>
      </Section>

      <Section>
        {supplyForCountry.length === 0 ? (
          <div className="border rounded-md py-12 text-center text-muted-foreground">
            No signal sources recorded for {cc.name} yet.
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {supplyForCountry.map((s) => (
              <RouterLink
                key={s.id}
                to={`/docs/datasets/${cc.code}/supply/${s.id}`}
                className="group block rounded-lg border bg-card hover:border-primary hover:shadow-sm transition-all p-5"
              >
                <h3 className="font-semibold text-sm group-hover:text-primary transition-colors mb-1.5">
                  {s.shortName}
                </h3>
                <p className="text-xs text-muted-foreground line-clamp-3 mb-2">{s.description}</p>
                {s.latestData && (
                  <p className="text-[11px] text-muted-foreground">{s.latestData}</p>
                )}
              </RouterLink>
            ))}
          </div>
        )}
      </Section>
    </div>
  )
}
